import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "search-box"
};
const _hoisted_2 = {
  class: "channel-title-block"
};
const _hoisted_3 = {
  class: "channel-title"
};
const _hoisted_4 = {
  class: "video-toolbar"
};
const _hoisted_5 = {
  key: 0,
  class: "custom-tabs"
};
const _hoisted_6 = ["onClick"];
const _hoisted_7 = {
  class: "tab-label"
};
const _hoisted_8 = {
  class: "tab-text"
};
const _hoisted_9 = {
  class: "tab-count"
};
const _hoisted_10 = {
  key: 1,
  class: "view-toggle"
};
const _hoisted_11 = {
  class: "tab-panel"
};
const _hoisted_12 = {
  key: 0,
  class: "empty-text"
};
const _hoisted_13 = {
  key: 1,
  class: "empty-text"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_b_icon = _resolveComponent("b-icon");
  const _component_router_link = _resolveComponent("router-link");
  const _component_b_col = _resolveComponent("b-col");
  const _component_search_chips = _resolveComponent("search-chips");
  const _component_b_row = _resolveComponent("b-row");
  const _component_b_spinner = _resolveComponent("b-spinner");
  const _component_Livestream = _resolveComponent("Livestream");
  const _component_b_pagination = _resolveComponent("b-pagination");
  const _component_VideoList = _resolveComponent("VideoList");
  return _openBlock(), _createElementBlock("div", null, [!$data.loading ? (_openBlock(), _createBlock(_component_b_row, {
    key: 0,
    class: "video-header align-items-center"
  }, {
    default: _withCtx(() => [_createVNode(_component_b_col, {
      cols: "6",
      class: "d-flex align-items-center"
    }, {
      default: _withCtx(() => [$data.channels.length > 1 ? (_openBlock(), _createBlock(_component_router_link, {
        key: 0,
        to: "/video/channel",
        class: "back-link"
      }, {
        default: _withCtx(() => [_createVNode(_component_b_icon, {
          icon: "arrow-left"
        }), _cache[6] || (_cache[6] = _createTextVNode(" Back to Channels ", -1))], undefined, true),
        _: 1
      })) : _createCommentVNode("", true)], undefined, true),
      _: 1
    }), _createVNode(_component_b_col, {
      cols: "6",
      class: "d-flex justify-content-end"
    }, {
      default: _withCtx(() => [!$options.isLiveTab ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_search_chips, {
        ref: "chips",
        modelValue: $data.searchTerms,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.searchTerms = $event),
        compact: "",
        placeholder: "Search videos...",
        onSearch: _cache[1] || (_cache[1] = $event => $options.getVideos())
      }, null, 8, ["modelValue"])])) : _createCommentVNode("", true)], undefined, true),
      _: 1
    })], undefined, true),
    _: 1
  })) : _createCommentVNode("", true), $data.loading ? (_openBlock(), _createBlock(_component_b_row, {
    key: 1
  }, {
    default: _withCtx(() => [_createVNode(_component_b_col, {
      cols: "12",
      class: "text-center"
    }, {
      default: _withCtx(() => [_createVNode(_component_b_spinner), _cache[7] || (_cache[7] = _createElementVNode("br", null, null, -1)), _cache[8] || (_cache[8] = _createTextVNode("Loading Videos", -1)), _cache[9] || (_cache[9] = _createElementVNode("br", null, null, -1)), _cache[10] || (_cache[10] = _createElementVNode("br", null, null, -1))], undefined, true),
      _: 1
    })], undefined, true),
    _: 1
  })) : _createCommentVNode("", true), !$data.loading && $options.currentChannelName ? (_openBlock(), _createBlock(_component_b_row, {
    key: 2,
    class: "channel-title-row"
  }, {
    default: _withCtx(() => [_createVNode(_component_b_col, {
      cols: "12"
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("h2", _hoisted_3, _toDisplayString($options.currentChannelName), 1), _cache[11] || (_cache[11] = _createElementVNode("hr", {
        class: "channel-title-divider"
      }, null, -1))])], undefined, true),
      _: 1
    })], undefined, true),
    _: 1
  })) : _createCommentVNode("", true), !$data.loading ? (_openBlock(), _createBlock(_component_b_row, {
    key: 3
  }, {
    default: _withCtx(() => [_createVNode(_component_b_col, {
      cols: "12"
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_4, [$options.allTabs.length ? (_openBlock(), _createElementBlock("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.allTabs, (tab, index) => {
        return _openBlock(), _createElementBlock("button", {
          key: tab.key || tab.id || index,
          type: "button",
          class: _normalizeClass(["custom-tab", {
            active: $data.currentTab === index
          }]),
          onClick: $event => $data.currentTab = index
        }, [_createElementVNode("span", _hoisted_7, [_createVNode(_component_b_icon, {
          icon: tab.iconClass || 'broadcast'
        }, null, 8, ["icon"]), _createElementVNode("span", _hoisted_8, _toDisplayString(tab.title), 1), _createElementVNode("span", _hoisted_9, _toDisplayString(tab.totalResults || 0), 1)])], 10, _hoisted_6);
      }), 128))])) : _createCommentVNode("", true), !$options.isLiveTab ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_createElementVNode("button", {
        type: "button",
        class: _normalizeClass(["view-btn", {
          active: $data.display === 0
        }]),
        onClick: _cache[2] || (_cache[2] = $event => $data.display = 0)
      }, [_createVNode(_component_b_icon, {
        icon: "grid-fill"
      })], 2), _createElementVNode("button", {
        type: "button",
        class: _normalizeClass(["view-btn", {
          active: $data.display === 1
        }]),
        onClick: _cache[3] || (_cache[3] = $event => $data.display = 1)
      }, [_createVNode(_component_b_icon, {
        icon: "list"
      })], 2)])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_11, [$options.isLiveTab ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createVNode(_component_Livestream, {
        channelId: $data.channel_id,
        liveOnly: true,
        hideChannelLink: true,
        onListCount: $options.setLiveCount
      }, null, 8, ["channelId", "onListCount"]), $data.liveCount === 0 ? (_openBlock(), _createElementBlock("h2", _hoisted_12, " No live streams are available on this channel right now ")) : _createCommentVNode("", true)], 64)) : $options.activeVideoTab ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [$options.activeVideoTab.pagination && $options.activeVideoTab.totalResults > $options.activeVideoTab.pagination.perPage ? (_openBlock(), _createBlock(_component_b_pagination, {
        key: 0,
        align: "right",
        class: "mt-4",
        modelValue: $options.activeVideoTab.pagination.page,
        "onUpdate:modelValue": [_cache[4] || (_cache[4] = $event => $options.activeVideoTab.pagination.page = $event), _cache[5] || (_cache[5] = $event => $options.updatePage($event))],
        "total-rows": $options.activeVideoTab.totalResults
      }, null, 8, ["modelValue", "total-rows"])) : _createCommentVNode("", true), _createVNode(_component_VideoList, {
        displayType: $data.display === 0 ? 'grid' : 'list',
        videoObject: $options.activeVideoTab,
        onPlay: $options.showVideo,
        onUpdateVideoFavoriteStatus: $options.updateVideoFavoriteStatus
      }, null, 8, ["displayType", "videoObject", "onPlay", "onUpdateVideoFavoriteStatus"]), $options.activeVideoTab.totalResults === 0 && !$data.loading ? (_openBlock(), _createElementBlock("h2", _hoisted_13, " This channel has not uploaded a video yet ")) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true)])], undefined, true),
      _: 1
    })], undefined, true),
    _: 1
  })) : _createCommentVNode("", true)]);
}